import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { BaseConfigurableComponent } from '@app/base-config.component';
import { ModalService } from '@app/services/modal/modal.service';
import { SchedulerStepService } from '@app/services/step/scheduler-step.service';
import { Router } from '@angular/router';
import { CategoriesService } from '@app/services/categories/categories.service';

@Component({
  selector: 'afcu-navigation',
  standalone: true,
  imports: [],
  providers: [ModalService],
  templateUrl: './navigation.component.html'
})
export class NavigationComponent extends BaseConfigurableComponent{
  
  protected schedulerService = inject( SchedulerStepService );
  protected categoriesService = inject( CategoriesService );
  protected router = inject( Router );

  constructor (private location: Location, private modalService: ModalService){
    super('page')
    this.getOrigin()
  }

  goTo(): void {

    this.categoriesService.searchQuery.set('')

    if (['/check-in'].includes(this.router.url)) {
      this.router.navigate(['/splash'])
      return;
    }

    if (this.router.url.includes('service')){
      if(this.route.snapshot.queryParamMap.get('origin') === 'queue'){
        this.router.navigate(['/splash'], {queryParamsHandling:'preserve'})
      }else{
        this.modalService.openModal('/branches-location', 'navigation')
      }
      return;
    } 
    
    // Calendar screen - go back to services
    if (this.router.url === '/calendar') {
      const branchId = this.schedulerService.branchSelected().branchID || 
                      this.route.snapshot.queryParamMap.get('branch');
      if (branchId) {
        this.schedulerService.payload.set({})
        this.router.navigate(['/services', branchId]);
      } else {
        this.router.navigate(['/branches-location']);
      }
      return;
    } 
    
    // Contact info screen - go back to calendar
    if (this.router.url === '/contact-info') {
      this.router.navigate(['/calendar'], {queryParamsHandling: 'merge'});
      return;
    }

    // Normal navigation
    this.location.back();
  }
}
